<template>
    <div class="row">
        <div class="col-sm-6">
            <div class="copyright">
                <p>© 2023 Informativ</p>
                <p>2801 Network Blvd., Ste. 650, Frisco, TX 75034</p>
                <p>
                    800-448-0183
                </p>
                <p><a href="mailto:info@informativ.com">info@informativ.com</a></p>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="footer-links">
                <a href="../Home/Logout">Logout</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CreditDriverFooter"
    };
</script>